<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenterb"><a id="ch00_fm05"></a><a id="page_v"><em>For two of the Other Women in my life: my agent, Jane Otte, and my editor, Susanne Kirk, who forgive my literary trespasses but don’t let me get away with them.</em></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05.vue?df2500b8